import React, { ButtonHTMLAttributes } from "react"
import "./LearnerButton.style.scss"

type LearnerButtonProps = {
  children: React.ReactNode
  loading?: boolean
  loadingText?: string
  fullWidth?: boolean
  variant?: "primary" | "secondary"
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children">

const LearnerButton = ({
  children,
  loading = false,
  loadingText = "Processing…",
  fullWidth = false,
  variant = "primary",
  disabled,
  type = "button",
  className = "",
  ...rest
}: LearnerButtonProps) => {
  const isDisabled = disabled || loading

  return (
    <button
      type={type}
      className={`learner-button learner-button--${variant} ${
        fullWidth ? "learner-button--full" : ""
      } ${className}`.trim()}
      disabled={isDisabled}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? (
        <>
          <span className="learner-button__spinner" aria-hidden />
          {loadingText}
        </>
      ) : (
        children
      )}
    </button>
  )
}

export default LearnerButton
